import React from 'react';
import useBusinessGuard from '../../../../hooks/useBusinessGuard';
import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
// import { Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { sanitizeWhatsAppFields } from '../../../../utils/sanitizeWhatsApp';
import {
  AddTaxiListing,
  UpdateTaxiListing,
  getCarBrand,
  getCarModelYear,
  AddMedia,
  getTaxiListing,
} from './../../../../Redux/Actions/UserAction';
import Sidebar from '../../../common/Sidebar/Sidebar';
import MapModal from '../../../common/Modal/MapModel';
import LogoCropModal from '../../../common/Modal/LogoCropModal';
import { useTranslation } from 'react-i18next';
import { CommonBusinessHeader } from '../CommonBusinessHeader';

// const API = 'https://api.carsavenue.com/api';
const API = 'https://api.carsavenue.com/api';

const getUploadConfig = () => ({
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
});

export default function TaxiBusiness() {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] The brand dropdown listed TOYOTA / CHEVROLET / NISSAN in
     English on the Arabic site. Every brand in the master carries `nameAr`, so
     show the one that matches the language. */
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandLabel = (brand) =>
    (isRTL ? brand?.nameAr || brand?.name : brand?.name || brand?.nameAr) || '';

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: 'all' });

  const dispatch = useDispatch();

  // One business per account: redirect if the user already owns a
  // different business instead of failing this add-form on save.
  useBusinessGuard('CAR11');

  const pendingLogoUploadRef = useRef(false);
  /* [CF 2026-08-11] The uploaded logo id arrives asynchronously in the effect
     below, but other effects (the prefill and the mobileNumbers rebuild) also
     call setState from their own stale snapshot and can drop it before submit —
     the save then re-sends the OLD id, which the owner sees as "the logo did not
     change". This ref is written the instant the upload resolves and applied
     again at submit time, so it cannot be clobbered. */
  const logoIdRef = useRef(null);
  const logoid = useSelector((state) => state.home.AddMediaList);

  const home = useSelector((state) => state?.home);

  const CarBrand = home?.garageCarBrandList;
  const CarModelYear = home?.CarModelYears;
  const TaxiOwner = home?.TaxiOwnerList;
  const getMybusiness = home?.getMybusiness;

  // The owner's business id can arrive two ways after a reload: from
  // sessionStorage (set by the Header once /business/my resolves) or directly
  // from the Redux getMybusiness object. Prefer whichever is available so the
  // form refetches and repopulates after a save+reload.
  const ownerBid =
    (getMybusiness?.businessId && String(getMybusiness.businessId)) ||
    sessionStorage.getItem('BusinessId');
  const validBid =
    ownerBid && ownerBid !== 'undefined' && ownerBid !== 'null' && ownerBid !== '';

  // Authoritative "do I already own this (taxi) business?". getMybusiness is set
  // once /business/my resolves and is NOT clobbered by the listing fetch — which
  // can momentarily return empty and flip TaxiOwner to []. Deciding add-vs-update
  // off TaxiOwner alone caused a POST (→ "already registered") on an existing
  // business. So treat the business as existing if EITHER source says so.
  const ownsTaxiBusiness =
    getMybusiness?.businessCode === 'CAR11' && !!getMybusiness?.businessId;
  const businessExists = (TaxiOwner?.length || 0) > 0 || ownsTaxiBusiness;

  const [LogoImage, setLogoImage] = useState();
  const [CarImage, setCarImage] = useState();
  const [LicenseImage, setLicenseImage] = useState();
  // true = hidden from users (backend `invisible` boolean); false = visible.
  const [invisible, setInvisible] = useState(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  // Cropper state: { src, name } of the just-picked logo, shown in the modal.
  const [cropSrc, setCropSrc] = useState(null);
  const [cropName, setCropName] = useState('');
  // Additional phone numbers beyond the primary phone + whatsapp. Each entry is
  // { countryCode, mobileNumber }. Appended to mobileNumbers on submit.
  const [extraPhones, setExtraPhones] = useState([]);
  const addExtraPhone = () =>
    setExtraPhones((p) => [...p, { countryCode: '+965', mobileNumber: '' }]);
  const removeExtraPhone = (i) =>
    setExtraPhones((p) => p.filter((_, idx) => idx !== i));
  const updateExtraPhone = (i, key, value) =>
    setExtraPhones((p) =>
      p.map((row, idx) => (idx === i ? { ...row, [key]: value } : row))
    );
  const [TaxiData, setTaxiData] = useState({
    taxiCompanyName: '',
    gps: {
      lat: '3.455',
      long: '34.45',
    },
    plateNumber: '',
    mobileNumberCountryCode: '',
    mobileNumber: '',
    mobileNumbers: [
      {
        countryCode: '',
        mobileNumber: '',
      },
    ],
    whatsAppNumber: '',
    whatsAppNumberCountryCode: '',
    invisible: true,
    location: '',
    car: '',
    modelYearId: '',
    vehicleType: '',
    mediaIds: {
      LOGO: [''],
      LICENSE: [''],
    },
  });

  useEffect(() => {
    // Only pre-fill when the owner's own listing is present. Guard with optional
    // chaining so an empty array / undefined (e.g. right after a save+reload)
    // doesn't throw and blank the page.
    if (TaxiOwner?.length) {
      let gps;
      try {
        gps =
          typeof TaxiOwner[0]?.gps === 'string'
            ? JSON.parse(TaxiOwner[0]?.gps)
            : TaxiOwner[0]?.gps;
      } catch (e) {
        gps = undefined;
      }
      setInvisible(!!TaxiOwner[0]?.invisible);
      // [CF] re-send existing media on name-only edits
      const logoItem = TaxiOwner[0]?.businessMedia?.find(
        (i) => i?.mediaType === 'LOGO'
      );
      const licenseItem = TaxiOwner[0]?.businessMedia?.find(
        (i) => i?.mediaType === 'LICENSE'
      );
      const carImageItem = TaxiOwner[0]?.businessMedia?.find(
        (i) => i?.mediaType === 'IMAGES'
      );
      const logoMediaId = logoItem?.mediaId || logoItem?.media?.mediaId;
      const licenseMediaId =
        licenseItem?.mediaId || licenseItem?.media?.mediaId;
      const carImageMediaId =
        carImageItem?.mediaId || carImageItem?.media?.mediaId;
      setTaxiData({
        taxiCompanyName: TaxiOwner[0]?.taxiCompanyName,
        plateNumber: TaxiOwner[0]?.plateNumber,
        vehicleType: TaxiOwner[0]?.vehicleType || '',
        mobileNumberCountryCode: TaxiOwner[0]?.mobileNumberCountryCode,
        mobileNumber: TaxiOwner[0]?.mobileNumber,
        car: TaxiOwner[0]?.car,
        modelYearId: TaxiOwner[0]?.modelYearId,
        whatsAppNumber: TaxiOwner[0]?.whatsAppNumber,
        whatsAppNumberCountryCode: TaxiOwner[0]?.whatsAppNumberCountryCode,
        location: TaxiOwner[0]?.location || '',
        gps: {
          lat: gps?.lat,
          long: gps?.long,
        },
        // [CF] re-send existing media on name-only edits
        mediaIds: {
          LOGO: logoMediaId ? [logoMediaId] : [''],
          LICENSE: licenseMediaId ? [licenseMediaId] : [''],
          ...(carImageMediaId ? { IMAGES: [carImageMediaId] } : {}),
        },
      });
      setLogoImage(
        TaxiOwner
          ? TaxiOwner[0]?.businessMedia.filter(
              (data) => data.mediaType === 'LOGO'
            )[0]?.media?.path
          : ''
      );
      setLicenseImage(
        TaxiOwner
          ? TaxiOwner[0]?.businessMedia.filter(
              (data) => data.mediaType === 'LICENSE'
            )[0]?.media?.path
          : ''
      );
      setCarImage(
        TaxiOwner
          ? TaxiOwner[0]?.businessMedia.filter(
              (data) => data.mediaType === 'IMAGES'
            )[0]?.media?.path
          : ''
      );

      // Load any saved numbers beyond the first two (phone + whatsapp) into the
      // additional-phones editor so they show up and can be edited.
      const _savedNums = TaxiOwner[0]?.mobileNumbers;
      if (Array.isArray(_savedNums) && _savedNums.length > 2) {
        setExtraPhones(
          _savedNums.slice(2).map((n) => ({
            countryCode: n?.countryCode || '+965',
            mobileNumber: n?.mobileNumber || '',
          }))
        );
      }
    }
  }, [TaxiOwner]);

  useEffect(() => {
    dispatch(getCarBrand());
    dispatch(getCarModelYear());
  }, [dispatch]);

  useEffect(() => {
    // Fetch the owner's OWN taxi business as soon as its id is known. Runs again
    // when the id becomes available post-reload (Header resolves it async),
    // which fixes the blank form after creating/updating a business.
    if (validBid) {
      var data = {
        taxiOwnerId: ownerBid,
      };
      dispatch(getTaxiListing(data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerBid]);

  function handleChange(e) {
    const { name, value } = e.target;
    setTaxiData((user) => ({ ...user, [name]: value }));
  }

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  const handleLocationSelect = (location) => {
    setTaxiData((prev) => ({
      ...prev,
      location: location.address,
      gps: {
        lat: location.lat,
        long: location.long,
      },
    }));
  };

  // Logo picker: instead of uploading immediately, validate + open the cropper.
  const handleUploadLogo = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type || !file.type.startsWith('image/')) {
      Swal.fire({
        title: 'Invalid file',
        text: 'Please upload an image file (JPG, PNG, etc.).',
        icon: 'error',
      });
      event.target.value = '';
      return;
    }
    const MAX_MB = 12;
    if (file.size > MAX_MB * 1024 * 1024) {
      Swal.fire({
        title: 'Image too large',
        text: `Please upload an image smaller than ${MAX_MB} MB.`,
        icon: 'error',
      });
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = (ev) => {
      setCropName(file.name || 'logo');
      setCropSrc(ev.target.result);
    };
    reader.readAsDataURL(file);
    event.target.value = '';
  };

  // Upload a cropped square logo (called by the cropper modal's Apply button).
  const uploadCroppedLogo = (result) => {
    setCropSrc(null);
    if (!result || !result.file) return;
    // The preview <img> reads LogoImage, so set it to the cropped data URL.
    if (result.preview) setLogoImage(result.preview);
    const formData = new FormData();
    formData.append('media', result.file);
    // silent: the inline preview is the confirmation, so no success popup.
    pendingLogoUploadRef.current = true;
    dispatch(AddMedia({ formData, silent: true }));
  };

  // Wire the silent logo upload's mediaId into the form payload.
  /* [CF 2026-08-09 #18] `home.AddMediaList` is a GLOBAL redux slot written by
     every media upload anywhere in the app, and nothing ever clears it. This
     effect therefore also fired on MOUNT, off whatever the last upload had
     left behind, silently stamping the PREVIOUS company's logo id into this
     form — save it and that company's logo came back, which is the "updating
     one company's logo reverts the other one" report. Consume the slot only
     when THIS page actually started an upload; same guard the `*Banner.js`
     screens already carry as `pendingUploadRef`. */
  useEffect(() => {
    if (!pendingLogoUploadRef.current) return;
    pendingLogoUploadRef.current = false;
    if (logoid !== undefined) {
      const LogoId = logoid?.data?.response?.media[0]?.mediaId;
      logoIdRef.current = LogoId;
      if (LogoId) {
        setTaxiData((prev) => ({
          ...prev,
          mediaIds: {
            ...prev.mediaIds,
            LOGO: [LogoId],
          },
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoid]);

  const handleUploadImage = (event) => {
    const id = event.target.id;
    const file = event.target.files[0];

    const reader = new FileReader();
    console.log('this is the reader section ', id);
    reader.readAsDataURL(file);

    const formData = new FormData();

    formData.append('media', file);

    axios
      .post(API + '/media/new', formData, getUploadConfig())

      .then((res) => {
        console.log('this is response', res.data.response.media[0].mediaId);
        Swal.fire({
          title: 'Upload Successfully',
          icon: 'success',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });

        const LogoId = res?.data?.response?.media[0]?.mediaId;
        if (id === 'Image') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setLogoImage(reader.result);
          };

          console.log('logoid', LogoId);

          setTaxiData({
            ...TaxiData,
            mediaIds: {
              ...TaxiData.mediaIds,
              LOGO: [LogoId],
            },
          });
        } else if (id === 'CarImage') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setCarImage(reader.result);
          };

          setTaxiData({
            ...TaxiData,
            mediaIds: {
              ...TaxiData.mediaIds,
              IMAGES: [LogoId],
            },
          });
        } else if (id === 'License') {
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            setLicenseImage(reader.result);
          };

          setTaxiData({
            ...TaxiData,
            mediaIds: {
              ...TaxiData.mediaIds,
              LICENSE: [LogoId],
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title:
            err?.response !== undefined
              ? err?.response?.data?.response?.message
              : 'something went wrong Upload again!!!',
          icon: 'error',
          imageUrl: './assets/images/favicon/android-chrome-192x192.png',
          imageHeight: 100,
          text: '',
          type: 'success',
          confirmButtonColor: '#3ab1f7',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        });
      });
  };

  // useEffect(() => {
  // 	setTaxiData({
  // 		...TaxiData,
  // 		gps: {
  // 			"lat": "3.455",
  // 			"long": "34.45"
  // 		},
  // 		mobileNumbers: [
  // 			{
  // 				countryCode: TaxiData.mobileNumberCountryCode,
  // 				mobileNumber: TaxiData.mobileNumber,
  // 			},
  // 			{
  // 				countryCode: TaxiData.whatsAppNumberCountryCode,
  // 				mobileNumber: TaxiData.whatsAppNumber,
  // 			}
  // 		]
  // 	})
  // }, [TaxiData.mobileNumberCountryCode,
  // 	TaxiData.mobileNumber,
  // 	TaxiData.whatsAppNumberCountryCode,
  // 	TaxiData.whatsAppNumber,])
  console.log('TaxiOwner', TaxiOwner);

  // Block a second Save click from firing a duplicate create while in flight.
  const submittingRef = useRef(false);

  const datasubmit = () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setTimeout(() => {
      submittingRef.current = false;
    }, 4000);
    // Update when the business already exists (per the authoritative signal),
    // otherwise create. Never POST when the user already owns a taxi business.
    // The reactive mobileNumbers effect is disabled in this form, so build the
    // primary phone + whatsapp entries here and append the additional phones.
    const _extra = extraPhones.filter(
      (p) => p.mobileNumber && String(p.mobileNumber).trim()
    );
    const _payload = sanitizeWhatsAppFields({
      ...TaxiData,
      mobileNumbers: [
        {
          countryCode: TaxiData.mobileNumberCountryCode,
          mobileNumber: TaxiData.mobileNumber,
        },
        {
          countryCode: TaxiData.whatsAppNumberCountryCode,
          mobileNumber: TaxiData.whatsAppNumber,
        },
        ..._extra,
      ],
    });
    if (logoIdRef.current) {
      _payload.mediaIds = {
        ..._payload.mediaIds,
        LOGO: [logoIdRef.current],
      };
    }
    if (businessExists) {
      dispatch(UpdateTaxiListing(_payload));
    } else {
      dispatch(AddTaxiListing(_payload));
    }
  };

  // Validate the form before submit. Returns an error message, or null if OK.
  const validateTaxi = () => {
    if (!TaxiData.taxiCompanyName || !String(TaxiData.taxiCompanyName).trim())
      return t('Please enter the business name.');
    if (!TaxiData.car) return t('Please select a car brand.');
    if (!TaxiData.plateNumber || !String(TaxiData.plateNumber).trim())
      return t('Please enter the plate number.');
    if (!/^\d{8}$/.test(String(TaxiData.mobileNumber || '')))
      return t('Phone number must be 8 digits.');
    if (
      TaxiData.whatsAppNumber &&
      !/^\d{8}$/.test(String(TaxiData.whatsAppNumber))
    )
      return t('WhatsApp number must be 8 digits.');
    if (!TaxiData.location || !String(TaxiData.location).trim())
      return t('Please select your location on the map.');
    return null;
  };

  const onSubmitGuarded = () => {
    const err = validateTaxi();
    if (err) {
      Swal.fire({ title: err, icon: 'warning' });
      return;
    }
    datasubmit();
  };

  const ResetHendler = () => {
    reset();
    setTaxiData({
      taxiCompanyName: '', gps: { lat: '', long: '' }, plateNumber: '',
      mobileNumberCountryCode: '', mobileNumber: '',
      mobileNumbers: [{ countryCode: '', mobileNumber: '' }],
      whatsAppNumber: '', whatsAppNumberCountryCode: '', invisible: true, location: '', car: '', modelYearId: '', vehicleType: '',
      mediaIds: { LOGO: [''], LICENSE: [''] },
    });
    setLogoImage(undefined);
    setCarImage(undefined);
    setLicenseImage(undefined);
  };

  // Flip visibility in one click via the sidebar toggle — no modal.
  const onToggleVisibility = () => {
    const next = !invisible;
    setInvisible(next);
    dispatch(UpdateTaxiListing({ invisible: next }));
  };

  /* [CF 2026-08-17 G4] Taxi is a "lite" category — no banner / services /
     working-hours pages exist for it — so its section list is the profile plus
     the plan. `noGate` keeps Manage Packages open: it is where the plan gets
     bought, and locking it behind having a plan would be a dead end. This is
     the same pair BuyPackages already builds for taxi, so the two screens now
     show an identical menu. */
  const sideBarOpt = [
    {
      icon: 'assets/images/icons/sp-business/manage-business.svg',
      link: '/sp-taxi-business',
      label: t('Manage Business'),
    },
    {
      icon: 'assets/images/icons/sp-business/manage-service.svg',
      link: '/manage-package',
      label: t('Manage Packages'),
      noGate: true,
    },
  ];

  const visibilityRow = businessExists ? (
    <div className="cav-visibility-row">
      <img src="assets/images/icons/sp-business/visible.svg" alt="" />
      <span>{invisible ? t('Hidden') : t('Visible')}</span>
      <label className="cav-switch" title={t('Show / hide my listing')}>
        <input
          type="checkbox"
          checked={!invisible}
          onChange={onToggleVisibility}
        />
        <span className="cav-switch-slider"></span>
      </label>
    </div>
  ) : null;

  return (
    <div>
      <CommonBusinessHeader dataList={TaxiOwner} getNameKey="taxiCompanyName" />

      <div class="main-content-area">
        <div class="container">
          <div class="row justify-content-between">
            {/* [CF 2026-08-17 G4] This column used to be hand-built markup, so
                Taxi never got the mobile hub every other category shows — a new
                owner was dropped straight onto the form while the rest landed
                on the section list. It now renders the shared Sidebar, which is
                what produces the hub. The visibility switch goes through
                `extra` so it keeps its place in the list.
                The old note here said taxis have no packages; they do — 28 taxi
                subscriptions exist in production — and BuyPackages already
                builds a taxi-correct menu, so the plan card is back. */}
            <Sidebar options={sideBarOpt} extra={visibilityRow} />

            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <h2> {t('Manage Business')}</h2>

              <form onSubmit={handleSubmit(onSubmitGuarded)}>
                <div class="form-group">
                  <label for="g-mb-business-name">{t('Name')}</label>
                  <input
                    name="taxiCompanyName"
                    type="text"
                    value={TaxiData.taxiCompanyName}
                    onChange={handleChange}
                    className="form-control"
                    id="g-mb-business-name"
                    placeholder={t('Business Name')}
                  />
                </div>

                <div class="form-group">
                  <label for="Brand">{t('Select Car Brand')}</label>
                  <select
                    class="form-control"
                    id="Brand"
                    name="car"
                    value={TaxiData.car}
                    onChange={handleChange}
                  >
                    <option>{t('- Select Car Brand -')}</option>
                    {CarBrand !== undefined && CarBrand.length
                      ? CarBrand.map((brand, idx) => (
                          <option value={brand.brandId}>{brandLabel(brand)}</option>
                        ))
                      : null}
                  </select>
                </div>

                <div class="form-group">
                  <label for="Model">{t('Select Car Model')}</label>
                  <select
                    class="form-control"
                    id="Model"
                    name="modelYearId"
                    value={TaxiData.modelYearId}
                    onChange={handleChange}
                  >
                    <option value="">- Select Car Model -</option>
                    {CarModelYear !== undefined && CarModelYear.length
                      ? CarModelYear.map((year, idx) => (
                          <option value={year.modelYearId}>
                            {year.modelYear}
                          </option>
                        ))
                      : null}
                  </select>
                </div>

                <div class="form-group">
                  <label for="Plate-Number">{t('Plate Number')}</label>
                  <input
                    name="plateNumber"
                    value={TaxiData.plateNumber}
                    onChange={handleChange}
                    type="text"
                    class="form-control"
                    id="Plate-Number"
                    placeholder={t('Plate Number')}
                  />
                </div>

                {/* [FB2-#21c] Vehicle Type (Sedan/SUV/...) — shown on the taxi
                    profile card. Optional; blank shows as "—" on the profile. */}
                <div class="form-group">
                  <label for="Vehicle-Type">{t('Vehicle Type')}</label>
                  <select
                    name="vehicleType"
                    id="Vehicle-Type"
                    class="form-control"
                    value={TaxiData.vehicleType || ''}
                    onChange={handleChange}
                  >
                    <option value="">- {t('Select Vehicle Type')} -</option>
                    <option value="Sedan">{t('Sedan')}</option>
                    <option value="SUV">{t('SUV')}</option>
                    <option value="Hatchback">{t('Hatchback')}</option>
                    <option value="Coupe">{t('Coupe')}</option>
                    <option value="Van">{t('Van')}</option>
                    <option value="Minivan">{t('Minivan')}</option>
                    <option value="Pickup">{t('Pickup')}</option>
                    <option value="Bus">{t('Bus')}</option>
                    <option value="Other">{t('Other')}</option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="g-mb-phone-number">{t('Phone Number')}</label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="mobileNumberCountryCode"
                        value={TaxiData.mobileNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option>{t('Country Code')}</option>
                        <option>+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        name="mobileNumber"
                        value={TaxiData.mobileNumber}
                        onChange={handleChange}
                        type="tel"
                        className="form-control"
                        id="g-mb-phone-number"
                        placeholder={t('Phone Number')}
                      />
                    </div>
                  </div>
                </div>

                {/* <p class='add-more'>
									<a
										class=''
										data-toggle='collapse'
										href='#collapseExample'
										role='button'
										aria-expanded='false'
										aria-controls='collapseExample'>
										Add More +
									</a>
								</p> */}
                <div class="collapse" id="collapseExample">
                  <div class="form-group">
                    <label for="g-mb-phone-number">Phone Number</label>
                    <div class="row">
                      <div class="col-4">
                        <select
                          class="form-control"
                          name="MoremobileNumberCountryCode"
                          value={TaxiData.mobileNumberCountryCode}
                          onChange={handleChange}
                        >
                          <option>{t('Country Code')}</option>
                          <option>+965</option>
                        </select>
                      </div>
                      <div class="col-8">
                        <input
                          name="MoremobileNumber"
                          value={TaxiData.MoremobileNumber}
                          onChange={handleChange}
                          type="tel"
                          className="form-control"
                          id="g-mb-phone-number"
                          placeholder={t("Phone Number")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="g-mb-whatsApp-number">
                    {t('WhatsApp Number')} <small>(Optional)</small>
                  </label>
                  <div class="row">
                    <div class="col-4">
                      <select
                        class="form-control"
                        name="whatsAppNumberCountryCode"
                        value={TaxiData.whatsAppNumberCountryCode}
                        onChange={handleChange}
                      >
                        <option>{t('Country Code')}</option>
                        <option>+965</option>
                      </select>
                    </div>
                    <div class="col-8">
                      <input
                        name="whatsAppNumber"
                        value={TaxiData.whatsAppNumber}
                        onChange={handleChange}
                        type="tel"
                        className="form-control"
                        id="g-mb-whatsApp-number"
                        placeholder={t("WhatsApp Number")}
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>
                    {t('Additional Phone Numbers')}{' '}
                    <small>({t('Optional')})</small>
                  </label>
                  {extraPhones.map((phone, idx) => (
                    <div class="row" key={idx} style={{ marginBottom: '8px' }}>
                      <div class="col-4">
                        <select
                          class="form-control"
                          value={phone.countryCode}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'countryCode', e.target.value)
                          }
                        >
                          <option value="+965">+965</option>
                        </select>
                      </div>
                      <div class="col-7">
                        <input
                          type="tel"
                          inputMode="numeric"
                          class="form-control"
                          value={phone.mobileNumber}
                          placeholder={t('Phone Number')}
                          onChange={(e) =>
                            updateExtraPhone(idx, 'mobileNumber', e.target.value)
                          }
                        />
                      </div>
                      <div class="col-1 px-0">
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-block"
                          title={t('Remove')}
                          onClick={() => removeExtraPhone(idx)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    onClick={addExtraPhone}
                  >
                    + {t('Add phone number')}
                  </button>
                </div>

                <div className="form-group">
                  <label htmlFor="g-mb-location-map">
                    {t('Select Location on Map')}
                  </label>
                  <div className="input-group">
                    <input
                      name="location"
                      value={TaxiData.location}
                      onChange={handleChange}
                      type="text"
                      className="form-control"
                      id="g-mb-location-map"
                      readOnly
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/map-marker.svg"
                          alt="Map"
                          style={{ height: '20px', width: '20px' }}
                        />
                      </button>
                    </div>
                  </div>
                  <small className="form-text text-muted">
                    {t(
                      'Click to open the map and select your business location'
                    )}
                  </small>
                </div>
                <MapModal
                  open={mapModalOpen}
                  handleClose={handleCloseMap}
                  onLocationSelect={handleLocationSelect}
                  currentLocation={{
                    lat: TaxiData.gps?.lat,
                    long: TaxiData.gps?.long,
                    address: TaxiData?.location,
                  }}
                />

                <LogoCropModal
                  open={!!cropSrc}
                  imageSrc={cropSrc}
                  fileName={cropName}
                  onCancel={() => setCropSrc(null)}
                  onApply={uploadCroppedLogo}
                />

                <div class="form-group">
                  <label>{t('Upload your image')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                            objectFit: 'cover',
                            border: '1px solid #e3e3e3',
                            background: '#f7f7f7',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            LogoImage ? LogoImage : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="Image"
                        >
                          {t('Upload your image')}
                        </label>
                        <input
                          type="file"
                          id="Image"
                          accept="image/*"
                          onChange={handleUploadLogo}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div class='form-group'>
									<div class='row align-items-center'>
										<div class='col-auto'>
											<div class='circle'>
												<img
													class='profile-pic img-fluid'
													src='assets/images/camera.jpg'
													alt=''
												/>
											</div>
										</div> */}

                {/* <div class='col-auto'>
											<div class='p-image'>
												<label
													// class='btn btn-outline-secondary upload-button btn-sm'
													class='profile-pic img-fluid'
													// role='button'
												>
													Upload your image
												</label>

												<input
													{...register('IMAGES', {
														// required: 'this field is requerd',
													})}
													name='IMAGES'
													value={TaxiData.IMAGES}
													onChange={mediaIdsChange}
													class='btn btn-outline-secondary upload-button btn-sm'
													type='file'
													accept='image/*'
													placeholder='Upload your image'
												/>
											</div>
										</div>
									</div>
								</div> */}
                <div class="form-group">
                  <label> {t('Upload License')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={
                            LicenseImage
                              ? LicenseImage
                              : 'assets/images/camera.jpg'
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="License"
                        >
                          {t('Upload License')}
                        </label>
                        <input
                          type="file"
                          id="License"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div class='form-group'>
									<div class='row align-items-center'>
										<div class='col-auto'>
											<div class='circle'>
												<img
													class='profile-pic img-fluid'
													src='assets/images/camera.jpg'
													alt=''
												/>
											</div>
										</div>
										<div class='col-auto'>
											<div class='p-image'>
												<a
													class='btn btn-outline-secondary upload-button btn-sm'
													href='javascript:void(0);'
													role='button'>
													Upload License
												</a>
												<input
													class='file-upload'
													type='file'
													accept='image/*'
												/>
											</div>
										</div>
									</div>
								</div> */}

                <div class="form-group">
                  <label> {t('Upload Car Image')}</label>
                  <div class="row align-items-center ">
                    <div class="col-auto">
                      <div class=" row-cols-7">
                        <img
                          style={{
                            height: '7rem',
                            width: '7rem',
                            borderRadius: '7rem',
                          }}
                          class="profile-pic img-fluid "
                          // src='assets/images/camera.jpg'
                          // src='/Screenshot (4).png'
                          src={CarImage ? CarImage : 'assets/images/camera.jpg'}
                          alt=""
                        />
                      </div>
                    </div>
                    <div class="col-auto">
                      <div class="p-image">
                        <label
                          class="btn btn-outline-secondary upload-button btn-sm"
                          for="CarImage"
                        >
                          {t('Upload Car Image')}
                        </label>
                        <input
                          type="file"
                          id="CarImage"
                          accept="image/*"
                          onChange={handleUploadImage}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Visibility is now a one-click sidebar toggle — modal removed. */}

                <div class="row">
                  <div class="col-6">
                    <button
                      onClick={ResetHendler}
                      type="reset"
                      class="btn btn-secondary btn-block"
                    >
                      {t('Reset')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      type="submit"
                      // to='/sp-taxi-business-packages'
                      class="btn btn-warning btn-block"
                      // href='/sp-taxi-business-packages'
                      // role='button'
                      onSubmit={datasubmit}
                    >
                      {TaxiOwner?.length ? t('Update') : t('Submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
